import { Directive, Input, OnDestroy, TemplateRef } from '@angular/core';
import { PortalTarget, PortalService } from './portal.service';

/**
 * Renders template in a different (usually global) DOM tree.
 *
 * Usage:
 * ```html
 *  <div *cignaPortal="'portal-key'; let context">This content will be teleported.</div>
 * ```
 */
@Directive({
  selector: '[cignaPortal]',
})
export class PortalDirective implements OnDestroy {
  private _currentTarget: PortalTarget;

  constructor(
    private _template: TemplateRef<any>,
    private _portalService: PortalService,
  ) {}

  @Input()
  set cignaPortal(target: PortalTarget) {
    if (!target) {
      throw new Error('Portal expects the target to be set!');
    }

    if (this._currentTarget && this._currentTarget !== target) {
      this._portalService.detach(this._currentTarget, this._template);
    }

    this._portalService.attach(target, this._template);
    this._currentTarget = target;
  }

  ngOnDestroy() {
    if (!this._currentTarget) {
      throw new Error('Portal has no correct target!');
    }

    this._portalService.detach(this._currentTarget, this._template);
  }
}
